export default __webpack_public_path__ + "static/media/remaining.26edc637.svg";